const BASE_MEDIA_URL = "https://media-app-notifyy-new.notifyy.io/";

// const notifyy = `${BASE_MEDIA_URL}notifyy_logo_cleaned.png`;
const notifyy = `${BASE_MEDIA_URL}notifyy-new-logo.png`;
const notifyyLogoText = `${BASE_MEDIA_URL}notifyy_logo.svg`;
const notifyyLogo = `${BASE_MEDIA_URL}notifyy_logo_text.svg`;
const whatsappChatDoodle = `${BASE_MEDIA_URL}whatsapp_chat_doodle_bg.png`;
const objectFormPreview = `${BASE_MEDIA_URL}object-form-preview.png`;
const linkwithphonenumber = `${BASE_MEDIA_URL}link_with_phonenumber.png`;
const whatsappFlowsAutomation = `${BASE_MEDIA_URL}whatsappFlows_automation.png`;

export const IMAGES = {
  notifyy,
  notifyyLogo,
  notifyyLogoText,
  whatsappChatDoodle,
  objectFormPreview,
  linkwithphonenumber,
  whatsappFlowsAutomation,
};

//CRM - Segments
const segmentDynamicPersonalization = `${BASE_MEDIA_URL}segment-dynamicPersonalization.png`;
const segmentEmailCampaigns = `${BASE_MEDIA_URL}segment-emailCampaigns.png`;
const segmentPerformanceAnalytics = `${BASE_MEDIA_URL}segment-performanceAnalytics.png`;
const segmentWorkflowAutomation = `${BASE_MEDIA_URL}segment-workflowAutomation.png`;

//Inbox
const noMesageGraphic = `${BASE_MEDIA_URL}noMesageGraphic.png`;

export const SEGMENT_IMAGES = {
  segmentDynamicPersonalization,
  segmentEmailCampaigns,
  segmentPerformanceAnalytics,
  segmentWorkflowAutomation,
  noMesageGraphic,
};

// WhatsApp payment provider logos — keys must match the backend
// `provider_name` enum (razorpay | payu | billdesk | zaakpay | upi_vpa).
const razorpayLogo = `${BASE_MEDIA_URL}razorpay_logo.png`;
const payuLogo = `${BASE_MEDIA_URL}payu_logo.png`;
const billdeskLogo = `${BASE_MEDIA_URL}billdesk_logo_1.png`;
const zaakpayLogo = `${BASE_MEDIA_URL}zaakpay_logo.png`;
const upiLogo = `${BASE_MEDIA_URL}upi_logo.png`;

export const PAYMENT_PROVIDER_LOGOS: Record<string, string> = {
  razorpay: razorpayLogo,
  payu: payuLogo,
  billdesk: billdeskLogo,
  zaakpay: zaakpayLogo,
  upi_vpa: upiLogo,
};

// Video conferencing provider logos — keys must match the booking-link
// `locationType` values (google_meet | zoom | microsoft_teams).
const googleMeetLogo = `${BASE_MEDIA_URL}LOGO_GMEET.png`;
const zoomLogo = `${BASE_MEDIA_URL}LOGO_ZOOM.png`;
const microsoftTeamsLogo = `${BASE_MEDIA_URL}LOGO_MTEAMS.png`;

export const VIDEO_PROVIDER_LOGOS: Record<string, string> = {
  google_meet: googleMeetLogo,
  zoom: zoomLogo,
  microsoft_teams: microsoftTeamsLogo,
};
